import axios from "axios";
import React, { useState , useEffect} from "react";

const CreateUserForm = ({ onClose, name }) => {
  console.log("name",name)
  const [application, setApplication] = useState([]);
  const [showNameSection, setShowNameSection] = useState(false);

  useEffect(() => {
    // Check if name exists and update state
    setShowNameSection(!!name);

    // Log true if name exists, false otherwise
    console.log("namedata", !!name);
  }, [name]);

  const [formValues, setFormValues] = useState({
    firstName: '',
    lastName: '',
    email: '',
    phoneNumber: '',
    password: '',
    roolSection: '8848',
    Package: '',
    createdby: 'admin',
    packageexpire:'',
    packageData:'',
    packageCreated:'',
  });

  const [roolSectionData, setRoolSectionData] = useState([]);
  const [error, setError] = useState({
    phoneNumber: '',
    email: '',
    password: '',
  });

  useEffect(() => {
    if (name && typeof name === "object" && !Array.isArray(name) && Object.keys(name).length > 0) {
      setFormValues((prev) => ({
        ...prev,
        ...name,
      }));
      setShowNameSection(true);
    } else if (Array.isArray(name) && name.length > 0) {
      setFormValues((prev) => ({
        ...prev,
        ...name[0],
      }));
      setShowNameSection(false);
    }
  }, [name]);
  


  const handleInputChange = (e) => {
    let { name, value } = e.target;
    let phoneNumberError = '';
    let emailError = '';
    let passwordError = '';

    if (name === "phoneNumber") {
      const phoneNumberPattern = /^[6-9]\d{9}$/;
      if (!phoneNumberPattern.test(value)) {
        phoneNumberError = "Invalid phone number. Please enter a valid 10-digit Indian phone number.";
      }
      value = value.replace(/[^0-9]/g, '');
    }

    if (name === "email") {
      const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/i;
      if (!emailPattern.test(value)) {
        emailError = "Invalid email address.";
      }
    }

    if (name === "password") {
        const passwordPattern = /^(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]).{8,}$/;
        if (!passwordPattern.test(value)) {
          passwordError =
            "Password must be at least 8 characters long, include 1 uppercase letter, 1 number, and 1 special character.";
        }
      }
      
    setError({
      ...error,
      phoneNumber: phoneNumberError,
      email: emailError,
      password: passwordError,
    });

    setFormValues({
      ...formValues,
      [name]: value,
    });
  };


useEffect(() => {
  console.log("Updated formValues:", formValues);

}, [formValues]);

  
const handleSubmit = async (e) => {
  e.preventDefault();
  
  const packagefind = formValues.Package;
  const matchedRool = application.find((rool) => rool.packageId === packagefind);
console.log("matchedRool",matchedRool)
  if (!matchedRool) {
    alert("Invalid package selection.");
    return;
  }

  const today = new Date();
  let expireDate = "";

  if (matchedRool.Validity && matchedRool.Validation) {
    const validityValue = parseInt(matchedRool.Validity);
    expireDate = new Date(today);

    switch (matchedRool.Validation.toLowerCase()) {
      case "days":
        expireDate.setDate(today.getDate() + validityValue);
        break;
      case "weeks":
        expireDate.setDate(today.getDate() + validityValue * 7);
        break;
      case "months":
        expireDate.setMonth(today.getMonth() + validityValue);
        break;
      case "years":
      case "year":
        expireDate.setFullYear(today.getFullYear() + validityValue);
        break;
      case "never":
        expireDate = "Never";
        break;
      default:
        console.error("Invalid Validation type:", matchedRool.Validation);
        expireDate = "Invalid";
    }
    
  }

  const formattedExpireDate = expireDate instanceof Date ? expireDate.toISOString().split("T")[0] : expireDate;

  const updatedValues = {
    ...formValues,
    packageCreated: today.toISOString().split("T")[0],
    packageexpire: formattedExpireDate,
    packageData: matchedRool,
  };
console.log("updatedValues",updatedValues)
  try {
    const response = await axios.post("http://localhost:4000/app-users", updatedValues);
    console.log("User Created:", response.data);
    onClose();
  } catch (error) {
    console.error("Error creating user:", error.response?.data || error.message);
    alert(error.response?.data?.error || "Failed to create user.");
  }
};
const handleSave = async (e) => {
  e.preventDefault();

  const updatedValues = {
    userId: formValues.userId,
    firstName: formValues.firstName,
    lastName: formValues.lastName,
    email: formValues.email,
    phoneNumber: formValues.phoneNumber,
    state: formValues.state,
    sections: formValues.sections || [],
    updateDate: new Date().toISOString(), 
  };

  console.log("updatedValues:", updatedValues);

  try {
    const response = await axios.put(
      `http://localhost:4000/update-user/${formValues.userId}`,
      updatedValues
    );
    console.log("User Updated:", response.data);
    onClose();
  } catch (error) {
    console.error("Error updating user:", error.response?.data || error.message);
    alert(error.response?.data?.error || "Failed to update user.");
  }
};

          const fetchRools = async () => {
            try {
              const response = await axios.get(`http://localhost:4000/getrool`);
              setRoolSectionData(response.data.Rool);
            } catch (error) {
              console.error('Error fetching rools:', error);
            }
          };
        
  const fetchapplication = async () => {
    try {
      const response = await axios.get(`http://localhost:4000/getadminpackage`);
      console.log(response.data.Rool);

      if (Array.isArray(response.data.Rool)) {
        console.log("package",response.data.Rool)
        setApplication(response.data.Rool);
      } else {
        setApplication([]); // Ensure it's always an array
      }
    } catch (error) {
      console.error('Error fetching rools:', error);
      setApplication([]); // Handle error case
    }
  };
  useEffect(() => {
    fetchRools();
    fetchapplication();
  }, []);
  console.log("roolSectionData",roolSectionData)
  return (
    <div className="modal fade show" aria-modal="true" role="dialog" style={{ display: "block" }}>
      <div className="modal-dialog modal-lg modal-dialog-centered" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Create Customer</h5>
            <button type="button" className="btn-close" onClick={onClose}></button>
          </div>
          <div className="modal-body ">
          <form id="formAuthentication" className="mb-3" onSubmit={handleSubmit}>
        <div className="mb-2">
          <label htmlFor="firstName" className="form-label">
            First Name <span style={{ color: "red" }}>*</span>
          </label>
          <input
            type="text"
            className="form-control"
            id="firstName"
            name="firstName"
            placeholder="Enter Your First Name"
            value={formValues.firstName}
            onChange={handleInputChange}
            required
          />
        </div>
        <div className="mb-2">
          <label htmlFor="lastName" className="form-label">
            Last Name <span style={{ color: "red" }}>*</span>
          </label>
          <input
            type="text"
            className="form-control"
            id="lastName"
            name="lastName"
            placeholder="Enter Your Last Name"
            value={formValues.lastName}
            onChange={handleInputChange}
            required
          />
        </div>
        <div className="mb-2">
          <label htmlFor="email" className="form-label">
            Email
          </label>
          <input
            type="email"
            id="email"
            className="form-control"
            name="email"
            placeholder="Enter Your Email Address"
            value={formValues.email}
            onChange={handleInputChange}
          />
          {error.email && <div style={{ color: 'red' }}>{error.email}</div>}
        </div>
        <div className="mb-2">
          <label htmlFor="phoneNumber" className="form-label">
            Phone Number <span style={{ color: "red" }}>*</span>
          </label>
          <input
            type="tel"
            pattern="[0-9]*"
            className="form-control mb-2 no-arrows"
            id="phoneNumber"
            name="phoneNumber"
            placeholder="Enter Your Phone Number"
            value={formValues.phoneNumber}
            onChange={handleInputChange}
            maxLength="10"
            required
          />
          {error.phoneNumber && <div style={{ color: 'red' }}>{error.phoneNumber}</div>}
        </div>
       
  
{!showNameSection && (
 <div className="mb-3">
 <label className="form-label" htmlFor="password">
   Password <span style={{ color: "red" }}>*</span>
 </label>
 <input
   type="password"
   id="password"
   className="form-control mb-2"
   name="password"
   placeholder="Enter Your Password"
   value={formValues.password}
   onChange={handleInputChange}
   required
 />
 {error.password && <div style={{ color: 'red' }}>{error.password}</div>}
</div>
)}
        {!showNameSection && (
        <div className="mb-3">
          <label className="form-label" htmlFor="Package">
            Package <span style={{ color: "red" }}>*</span>
          </label>
          <select
  id="Package"
  className="form-control mb-2"
  name="Package"   
  value={formValues.Package}
  onChange={handleInputChange}
  required
>
            <option value="">Select Package</option>
            {application.map((rool) => (
              <option key={rool.packageId} value={rool.packageId}>
                {rool.Name}
              </option>
            ))}
          </select>
        </div>
        )}
        {!showNameSection ? (
  <button type="submit" className="btn btn-primary" onClick={handleSubmit}>
    Create
  </button>
) : (
  <button type="submit" className="btn btn-primary" onClick={handleSave}>
    Save
  </button>
)}

      </form>
          </div>
        </div>
      </div>
    </div>
  )
}

export default CreateUserForm
